export default __webpack_public_path__ + "static/media/iso.e77915ba.svg";